import { fetcher } from '@common/utils/fetcher';

import { type User } from './UsersService';

export const getLikes = () =>
  fetcher<User[]>({
    url: '/likes',
    method: 'GET',
  });
